export default (entities) => ({
  getProjectItem(id) {
    return entities.ProjectItem.find(id);
  },
  getPublicItem(token) {
    return entities.ProjectItem.findPublic(token);
  },
});
